// src/config/contacts.js
// Здесь редактируйте контакты — шапка сама подхватит.
// Можно задать до трёх телефонов. Порядок сохранится.

export const CONTACTS = {
    phones: [
      { label: '+38 099 368 23 20', tel: '+380993682320' },
      { label: '+38 073 128 78 10', tel: '+380731287810' },
      // Добавьте третий номер, когда будет готов:
      // { label: '+38 0XX XXX XX XX', tel: '+380XXXXXXXXX' },
    ],
    email: 'info@momv.com.ua',
    // Укажите ваш реальный Telegram-хэндл/ссылку или оставьте пустым:
    telegram: 'https://t.me/momv_llc_bot', // например: https://t.me/momv
  };
